module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-tickets"
  }, [_c('top-subpage-section', [_c('page-header', {
    attrs: {
      "title": "Tickets"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-vcentered is-flex-mobile has-text-centered",
    class: [{
      'is-centered': !_vm.isDesktop
    }]
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "column"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.subnavs), function(subnav) {
    return _c('div', {
      key: "subnav.title",
      staticClass: "column is-narrow subnav-item"
    }, [_c('a', {
      staticStyle: {
        "cursor": "not-allowed"
      },
      attrs: {
        "title": "Coming Soon"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "src": require("../assets/ic_tickets.svg"),
        "width": "80"
      }
    }), _c('br'), _vm._v(" "), _c('h4', {
      staticClass: "text"
    }, [_vm._v("\n              " + _vm._s(subnav.title) + "\n            ")])])])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-tickets-sub-section",
    attrs: {
      "id": "tickets-sub-section"
    }
  }, [_c('page-subheader', {
    attrs: {
      "title": "Purchase Tickets"
    }
  }), _vm._v(" "), _c('div-container', [_c('div-columns', {
    attrs: {
      "paddingTop": "0"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content1)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [((_vm.subnavs[0].route && _vm.subnavs[0].route.length > 0) && !_vm.disabled) ? _c('h4', {
    staticClass: "button is-primary button-ticket",
    staticStyle: {
      "margin-top": "30px",
      "position": "relative"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.subnavs[0].route,
      "target": "_blank"
    }
  }, [_vm._v("Purchase Here")])]) : _c('h4', {
    staticClass: "button is-primary button-ticket disabled",
    staticStyle: {
      "margin-top": "30px",
      "position": "relative"
    },
    attrs: {
      "disabled": "true"
    }
  }, [_c('a', {
    attrs: {
      "href": '#'
    },
    on: {
      "click": function($event) {
        return $event.preventDefault();
      }
    }
  }, [_vm._v("Coming Soon")])])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content2)
    }
  })])], 1)], 1), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be7a1438","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Tickets.vue
// module id = 936
// module chunks = 1